import React from 'react';
import { Box, Modal, Typography } from '@mui/material';
import DownloadButton from './DownloadButton';
import LoadingIndicator from './LoadingIndicator';
import FormattedText from '../FormattedText';

/**
 * Modal reutilizable para mostrar contenido multimedia (imágenes, videos, etc.)
 * 
 * @param {Object} props
 * @param {boolean} props.open - Estado que controla si el modal está abierto
 * @param {Function} props.onClose - Función para cerrar el modal
 * @param {ReactNode} props.children - Contenido del modal (la imagen o video)
 * @param {string} props.caption - Texto descriptivo
 * @param {boolean} props.loading - Estado que indica si el contenido está cargando
 * @param {boolean} props.isDownloading - Estado que indica si se está descargando
 * @param {Function} props.onDownload - Función para manejar la descarga
 * @param {string} props.contentType - Tipo de contenido (imagen, video, etc.)
 */
const MediaModal = ({ 
    open,
    onClose,
    children,
    caption,
    loading = false,
    isDownloading = false,
    onDownload,
    contentType = 'multimedia'
}) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby={`${contentType}-modal`}
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: '90%',
                maxHeight: '90%',
                backgroundColor: 'background.paper',
                boxShadow: 24,
                p: 1,
                borderRadius: 2
            }}>
                {/* Contenedor para el contenido multimedia */}
                <Box sx={{ position: 'relative', minHeight: '200px', minWidth: '200px' }}>
                    {/* Indicador de carga */}
                    <LoadingIndicator 
                        contentType={contentType}
                        isLoading={loading}
                        size={40}
                    />
                    
                    {/* Contenido multimedia (pasado como children) */}
                    {children}
                    
                    {/* Botón de descarga */}
                    {!loading && onDownload && (
                        <DownloadButton
                            onDownload={onDownload}
                            isDownloading={isDownloading}
                            fileType={contentType}
                            progressSize={20}
                            sx={{
                                position: 'absolute',
                                top: 5,
                                right: 5,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                '&:hover': {
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                }
                            }}
                        />
                    )}
                </Box>
                
                {/* Caption/texto descriptivo */}
                {caption && !loading && (
                    <Box sx={{ mt: 1, p: 1 }}>
                        <FormattedText text={caption} />
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default MediaModal;